import { handleActions } from "redux-actions";
import { PRIVATE_ROUTE } from "./constants";

export const reducer = handleActions(
  {
    [PRIVATE_ROUTE.SAVE_LOGIN_URL]: (state, { payload }) => ({
      savedRequiredLoginUrl: payload
    }),
    [PRIVATE_ROUTE.DISCARD_LOGIN_URL]: () => ({
      savedRequiredLoginUrl: undefined
    })
  },
  {}
);
